// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"991":"227cf772a3935760","2024":"3793ec5044ccda62","3798":"091b8b3480caf74a","4456":"c92d3b743144863b","7348":"218be35287d5e6ae","9527":"6b042d6ae298a77f"}[chunkId] + ".css";
};